import { Injectable } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";

import { catchError, EMPTY, OperatorFunction, throwError } from "rxjs";

import { DialogService, SpinnerService } from "dspx-core";

import { RequestSaveResultStatus } from "../constants/request-save-result-status";

import { PopupInfo } from "../interfaces/popup-info.interface";

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  constructor(
    private dialogService: DialogService,
    private spinnerService: SpinnerService) {
  }

  public errorHandler(customErrorPopups?: Map<RequestSaveResultStatus, PopupInfo>): OperatorFunction<any, any> {
    return catchError((error: HttpErrorResponse) => {

      this.spinnerService.hideSpinner();

      // Custom handling of form validation errors
      if (error?.error?.StatusCode === 400 && error?.error?.Message) {
        const message = this.serverValidationErrorsToHtml(error?.error?.Message);
        this.dialogService.showSimplePopup(message, 'Unable to continue', 'OK');
        return EMPTY;
      }

      // Remapping error codes from strings to numbers (e.g. 'UpdatedSinceReadTime' => 2).
      // This is because the global error handler expects the numerical codes instead of the string codes,
      // whereas the API returns the server-side error enum as strings instead of codes.
      if (error?.status === 400 && error?.error?.status && typeof error.error.status === 'string') {
        const errorStatusEnumValue = RequestSaveResultStatus[error.error.status as string] as RequestSaveResultStatus;
        if (errorStatusEnumValue !== null && errorStatusEnumValue !== undefined) {
          error.error.status = errorStatusEnumValue;

          // Using a custom error popup if provided
          const customErrorPopup = customErrorPopups?.get(errorStatusEnumValue);
          if (customErrorPopup) {
            this.dialogService.showDialog(customErrorPopup.popupCode, customErrorPopup.model, customErrorPopup.data);
            return EMPTY;
          }
        }
      }

      // Let the global error handler handle the error
      return throwError(() => error);
    });
  }

  private serverValidationErrorsToHtml(validationErrors: string): string {
    return this.stringArrayToHtmlUnorderedList(this.serverValidationErrorsToStringArray(validationErrors));
  }

  private stringArrayToHtmlUnorderedList(array: string[]): string {
    const listItems = (array && array.map(item => `<li>${item}</li>`)) || [];
    return `<ul>${listItems.join('')}</ul>`;
  }

  private serverValidationErrorsToStringArray(validationErrors: string): string[] {
    return (validationErrors && validationErrors.split('\r\n').map(x => x && x.trim()).filter(x => !!x)) || [];
  }
}
